import React from 'react';
import ReactDOM from 'react-dom/client';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM, unmountRootsAsync} from 'redux-stores/ReduxDOMRender';

import ConnectionDetails from './ConnectionDetails';
import ConnectionDetailsTabState from './ConnectionDetailsTabState';

export default class ConnectionDetailsTabView extends BufferTabView<ConnectionDetailsTabState> {
  reactRoot: ReactDOM.Root | null = null;

  override render(): this {
    const props = {
      connectionId: this.model.get('connectionId'),
    };
    this.reactRoot = renderToDOM(<ConnectionDetails {...props} />, this.el, this.reactRoot);
    return this;
  }

  override removeAsync(callback: () => void): BufferTabView<ConnectionDetailsTabState> {
    unmountRootsAsync([this.reactRoot], () => {
      this.reactRoot = null;
      super.remove();
      callback();
    });
    return this;
  }
}

ConnectionDetailsTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
